import React, { Component } from 'react';
import { BrowserRouter as Router, Route} from "react-router-dom";
import ReactDOM from 'react-dom';
import {ReactGAInstance} from './connectors/ReactGAInstance.js';
import { Container, Grid, Button, Icon, Image, Popup} from 'semantic-ui-react';
import { PremiumUtil } from './utils/PremiumUtil';
import { Settings } from './Settings';
import PremiumSignupPopup from './premium/PremiumSignupPopup';
import MetaTags from 'react-meta-tags';
import {BlurMessages} from './BlurMessages.js';
import Parser from 'html-react-parser';

import 'semantic-ui-less/semantic.less';
import './theme/custom.css';

class NewPremium extends Component {
  constructor(props) {
    super(props);
    this.state = {
        loading: false,
        messageLoading: true,
        premiumOptions: []
    };
  }
  componentDidMount() {
      ReactGAInstance.PageView(this.props.location.pathname);
      PremiumUtil.SendSiteAnalytics("NewPremiumPage", "Visited", this.props.location.pathname + this.props.location.search );
      this.setPlanId();
    }
  componentDidUpdate(prevProps) {
    if(this.props.location != prevProps.location) {
      this.setPlanId();
    }
  }
  setPlanId() {
    if(this.props.location.search.indexOf("payment=express") > -1 || this.props.location.search.indexOf("action=buy") > -1) {
        //we need to get the cart right away and call the cartUrl
        PremiumUtil.GetCart("yearly").then(resp => {
            //if there is success than redirect to path providied by then API
            if(resp && resp.data && resp.data.cartUrl) {
                window.open(resp.data.cartUrl, "_self");
            }
        }).catch(err => {
            //else use the end point which we generated for a product
            //console.log("Mycommerce got error: ", err);
        });    
        //return from here    
        return;
    }
    //this.getPremiumOptions();
    this.translate();
  }
  translate() {
	let lang = "";
	try {
		//pick language from the URL if its present
		let parsedUrl = new URL(window.location.href);
		if(parsedUrl.pathname) {
            if(parsedUrl.pathname.indexOf("/premium/") > -1) {
                lang = parsedUrl.pathname.replace("/premium/", "");
                //check if its part of more path
                if(lang && lang.indexOf("/") > -1) {
                    lang = lang.split("/")[0];
                }
            } else if(parsedUrl.pathname.indexOf("/buy-premium/") > -1) {
                lang = parsedUrl.pathname.replace("/buy-premium/", "");
                //check if its part of more path
                if(lang && lang.indexOf("/") > -1) {
                    lang = lang.split("/")[0];
                }
            }
        } 
		if(!lang) {
			lang = navigator.language.toLowerCase() || navigator.userLanguage.toLowerCase();
		}
	}
	catch(err) {
		//some error happened we are not showing here
		//console.log("Error parsing url", err);
	}
	BlurMessages.init(lang).then(() => {
        BlurMessages.translate();
    }).catch((err) => {
        //do nothing right now;
    }).then(() => {
        var mainLoadingNode = document.getElementById("mainpremiumLoading");
        if(mainLoadingNode && mainLoadingNode.style) {
            mainLoadingNode.style.display = "none";
        }
        //this is to handle post success/error
        this.setState(c=> {
            c.messageLoading = false;
            return c;
        });
        this.getPremiumOptions();
    });
  }
  choosePlan(option) {
    PremiumUtil.SendSiteAnalytics("PremiumPlan", "Choose", option.value);
    window.open(option.cartUrl, "_self");
  }
  getCurrencySymbol(currency) {
    var currency_symbols = {
        'USD': '$', // US Dollar
        'EUR': '€', // Euro
        'CRC': '₡', // Costa Rican Colón
        'GBP': '£', // British Pound Sterling
        'ILS': '₪', // Israeli New Sheqel
        'INR': '₹', // Indian Rupee
        'JPY': '¥', // Japanese Yen
        'CNY': '¥', // Chinese Yuan
        'KRW': '₩', // South Korean Won
        'NGN': '₦', // Nigerian Naira
        'PHP': '₱', // Philippine Peso
        'PLN': 'zł', // Polish Zloty
        'PYG': '₲', // Paraguayan Guarani
        'THB': '฿', // Thai Baht
        'UAH': '₴', // Ukrainian Hryvnia
        'VND': '₫', // Vietnamese Dong
    };
    if(currency_symbols[currency]) {
        return currency_symbols[currency];
    }
    return (currency); //just adding extra space
  }
  getPremiumOptions() {
      this.setState(c=> {
          c.loading = true;
          c.invalidCoupon = false;
          return c;
      });
      PremiumUtil.GetCarts("monthly,yearly,halfyearly").then(resp=> {
          let carts = resp.data;
          let premiumOptions = [];
          let key = 1;
          if(carts["monthly"] && carts["monthly"].total) {
              var mAmount = carts["monthly"].total;
              if(carts["yearly"] && carts["yearly"].discount == 0) {
                carts["yearly"].totalWithoutDiscount = mAmount * 12;
              }
              if(carts["halfyearly"] && carts["yearly"].discount == 0) {
                carts["halfyearly"].totalWithoutDiscount = mAmount * 6;
              }
          }
          var evtLabel = "";
          if(carts) {
              for(let planKey in carts) {
                let cart = carts[planKey];
                let messageText = "";
                var perMonth = 0.00;
                var amount = cart.total.toFixed(2);
                var totalAmount = cart.totalWithoutDiscount.toFixed(2)
                let currencySymbol = this.getCurrencySymbol(cart.currency);
                if(currencySymbol === cart.currency) {
                    amount += " " + currencySymbol;
                    totalAmount += " " + currencySymbol;
                } else {
                    amount = currencySymbol + amount;
                    totalAmount = currencySymbol + totalAmount;
                }
                if(planKey === "monthly") {
                    messageText = this.translatePay("lpPayXEveryMonth", "Pay Monthly " + amount, currencySymbol, cart.total.toFixed(2), 1);
                    perMonth = cart.total;
                } else if(planKey === "halfyearly") {
                    messageText = this.translatePay("lpPayXEveryY", "Pay Twice a Year " + amount, currencySymbol, cart.total.toFixed(2), 6)
                    perMonth = cart.total/6;
                } else if(planKey === "yearly") {
                    messageText = this.translatePay("lpPayXEveryY", "Pay Once a Year " + amount, currencySymbol, cart.total.toFixed(2), 12)
                    perMonth = cart.total/12;
                }
                perMonth = perMonth.toFixed(2);
                let saveText = <span>&nbsp;</span>;
                let perc = 0;
                if(cart.total < cart.totalWithoutDiscount) {
                    perc = 100 * ((cart.totalWithoutDiscount - cart.total)/cart.totalWithoutDiscount);
                    perc = perc.toFixed(0);
                    //[TODO] have one more variable other than SalesText {1}
                    saveText = this.translateSave(perc);
                }
                let premiumOption = {
                    key: key,
                    fullPrice: (cart.total === cart.totalWithoutDiscount) ? <span>&nbsp;</span>: totalAmount,
                    total: cart.total,
                    totalWithoutDiscount: cart.totalWithoutDiscount,
                    perMonth: perMonth,
                    planKey: planKey,
                    cartUrl: cart.cartUrl,
                    payText: messageText,
                    hasTaxes: cart.hasTaxes,
                    saveText: saveText,
                    showInfoIcon: (cart.discount === 0) ? false : true,
                    isRecommended: false
                }
                if(planKey === "yearly") {
                    premiumOption.isRecommended = true;
                }
                premiumOptions.push(premiumOption);
                evtLabel += planKey+":"+perc + ","
              }
          }
          this.setState(c => {
              c.premiumOptions = premiumOptions;
              return c;
          })
          PremiumUtil.SendSiteAnalytics("Cart", "Created", evtLabel, {carts: JSON.stringify(premiumOptions)});
      }).catch(err => {
          //handle error gracefully
          PremiumUtil.SendSiteAnalytics("Cart", "Error", (err && err.message) ? err.message : JSON.stringify(err));
      }).then(() => {
          this.setState(c=> {
              c.loading = false;
              return c;
          })
      })
  }

  getPremiumPeriod() {
      switch (this.state.planKey) {
          case Settings.MyCommerceYearlyPlanKey : return "1-year";
          case Settings.MyCommerceHalfYearlyPlanKey : return "6-month";
          case Settings.MyCommerceMonthlyPlanKey : return "1-month";
      }
  }
  translateMessage(messageId, message) {
    var transMessg = BlurMessages.getMessage(messageId);
    if(transMessg === messageId) {
        return message;
    }
    transMessg = Parser(transMessg);
    return transMessg;
  }
  //[TODO] make it generic
  translateSave(savePerc) {
    var messageId = "SalesText {1}";
    var transMessg = BlurMessages.getMessage(messageId, savePerc);
    if(transMessg === messageId) {
        return "Save " + savePerc;
    }
    transMessg = Parser(transMessg);
    return transMessg;
  }
  translatePay(messageId, defaultMessage, currency, amount, period) {
    var transMessg = BlurMessages.getMessage(messageId, currency, amount, period);
    if(transMessg === messageId) {
        return defaultMessage;
    }
    transMessg = Parser(transMessg);
    return transMessg;
  }
  render() {
    if(this.state.messageLoading) {
        return (
            <Router>
                <div></div>
            </Router>
        )
    }
    return (
      <Router>
        <div className="buy-height">
          <MetaTags>
              <title>Blur.live Upgrade to Premium{this.appName}</title>
          </MetaTags>
          {(this.state.loading) ? (
            <div className="ui inverted active dimmer">
            <div className="ui massive text loader">{this.state.loadingMessage}</div>
            </div>
            ):("")}
          <Container>
            <Grid className='stackable'>
              <Grid.Row>
                {!this.state.planId ? (
                <div className="hero-top-margin">
                    <div className="buy-comparison-div hero-top-margin">
                        {this.state.premiumOptions.map(option => {                    
                            return (
                                <div className={option.isRecommended ? "buy-comparison-card recommended-card" : "buy-comparison-card"}>
                                    {option.isRecommended ? <div className="buy-best-option-label">{this.translateMessage("lpBestValue", "Best Value")}</div> : ""}
                                    <div className={option.fullPrice.type === "span" ? "buy-card-fullprice-empty" : "buy-card-fullprice" }>{option.fullPrice}</div>
                                    <div className="buy-card-payprice">{option.payText}</div>
                                    {(option.hasTaxes) ? (
                                        <div className="buy-card-taxes">{this.translateMessage("ppTaxesApplicable", Parser('(<span className="taxplus">+</span>applicable taxes)'))}</div>
                                    ):("")}
                                    <div className="buy-card-savepercent text-green">{option.saveText}
                                        {(option.showInfoIcon) ? (
                                        <Popup
                                        trigger={ <span className="buy-card-info-icon">&nbsp;<Icon name="info circle"/></span>  }
                                        position='top center'
                                        size='tiny'
                                        >
                                            <Popup.Content>
                                            {this.translateMessage("ppSavesToolTip", "Savings reflect regional discount for your country")} 
                                            </Popup.Content>
                                        </Popup> 
                                        ): ("")}
                                    </div>
                                    <div className="buy-plan-button">
                                        {option.isRecommended ? 
                                            <Button color='green' onClick={() => this.choosePlan(option)}>{this.translateMessage("lpBuyPremium", "Select")}</Button> : 
                                            <Button primary size='tiny' onClick={() => this.choosePlan(option)}>{this.translateMessage("lpBuyPremium", "Select")}</Button>
                                        }
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="buy-comparison-highlight">
                        <div className="buy-summary-highlight">
                            <Image src='/images/Blur_buy_free_risk_icon.svg' />
                            <div className="buy-summary-highlight-text">
                            <div className="buy-summary-highlight-title">{PremiumUtil.Translate("ppRiskFreeTitle", "Risk free: Cancel at any time")}</div>
                            <div className="buy-summary-highlight-descr">
                                {PremiumUtil.Translate("ppRiskFreeMsg", "Upon cancellation you will receive a refund for the unused portion of your subscription.")}
                                &nbsp;<a id="cancelHowLink" target="_blank" href="/support/cancelHow" className="nowrap">{PremiumUtil.Translate("ppHowToCancel", "Learn more")}</a>.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>) : ("")}
              </Grid.Row>
            </Grid>
          </Container>
        </div>
      </Router>
    );
  }
}
class IndexPremium extends Component {
    render() {
      return (
        <Router>
          <Route path="/" component={NewPremium} />
        </Router>
      );
    }
}

class ManageLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openSignup: false,
            accountExist: false,
            loading: true,
            loadingMessg: true,
            extensionSatus: "",
            trialMinsLeft: "",
            freePremiumMinsLeft: ""
        };
        this.checkDelta = 400;
        this.languageSelected = PremiumUtil.DetectLanguage();
    }
    componentDidMount() {
        this.getStatus();
        PremiumUtil.GetWhoAmI(this.languageSelected).then(resp => {
            // check if affiliate info is present and show affiliate banner
            if (resp && resp.affiliateObject) {
                if (document.getElementById('affiliateBlock')) {
                    document.getElementById('affiliateBlock').style.display = 'block';
                }
                if(resp.affiliateObject.logo && document.getElementById('affiliateBlockImg')) {
                    document.getElementById('affiliateBlockImg').style.display = 'block';
                    document.getElementById('affiliateBlockImg').src = resp.affiliateObject.logo;
                }
                if (document.getElementById('affiliateBlockLink')) {
                    document.getElementById('affiliateBlockLink').style.display = 'block';
                    if (document.getElementById('affiliateBlockLp') && resp.affiliateObject.infoPage) {
                        document.getElementById('affiliateBlockLp').href = resp.affiliateObject.infoPage;
                    }
                    if (document.getElementById('affiliateBlockLp') && resp.affiliateObject.affiliateString) {
                        document.getElementById('affiliateBlockLp').innerHTML = resp.affiliateObject.affiliateString;
                    }
                }
            }
            if (!this.props.isBuyAction && PremiumUtil.UserHasSubscription()) {
                this.setState(c => {
                    c.accountExist = true;
                    c.openSignup = true;
                    return c;
                });
            }
        }).catch(err => {}).then(() => {
            //to render again
            this.setState(c => {
                c.loading = false;
                return c;
            });
        });
        PremiumUtil.SetBlurMessages().then(()=>{}).catch(()=>{}).then(() => {
            this.setState(c => {
                c.loadingMessg = false;
                return c;
            });
        });
    }
    getStatus() {
        PremiumUtil.GetBlurStatus().then(resp => {
          if(resp && resp !== "") {
            //this means we got extension status
            this.setState(c => {
                c.extensionSatus = resp;
                return c;
            });
            if(resp === "trial") {
                this.getTrialMinsLeft();
            } else 
            if(resp === "premium") {
                this.getFreePremiumMinsLeft();
            } else {
                this.setStatus();
            }
        } else {
              // trying to get status again
            this.tryGetStatus();
          }
        }).catch(() => {
          this.tryGetStatus();
        })
    }
    tryGetStatus() {
        setTimeout(this.getStatus.bind(this), this.checkDelta);
    }
    getFreePremiumMinsLeft() {
        PremiumUtil.GetBlurFreePremiumMinsLeft().then(resp => {
          if(resp && resp !== "") {
            //this means we got blur days left
            this.setState(c => {
                c.freePremiumMinsLeft = resp;
                return c;
            }, this.setStatus.bind(this));
          }
        }).catch(() => {
            //do nothing here
        })
    }
    getTrialMinsLeft() {
        PremiumUtil.GetBlurTrialMinsLeft().then(resp => {
          if(resp && resp !== "") {
            //this means we got blur days left
            this.setState(c => {
                c.trialMinsLeft = resp;
                return c;
            }, this.setStatus.bind(this));
          }
        }).catch(() => {
            //do nothing here
        })
    }
    setStatus() {
        if(!BlurMessages.isMessagesLoaded) {
            setTimeout(this.setStatus.bind(this), this.checkDelta);
        }
        if(this.state.extensionSatus) {
            let extensionInfo = "";
            if(this.state.extensionSatus === "trial") {
                if(this.state.trialMinsLeft) {
                    let trialLeftTxt = "";
                    if(this.state.trialMinsLeft > (60*25)) {
                        let daysLeft = Math.ceil(this.state.trialMinsLeft/(60*24));
                        trialLeftTxt = PremiumUtil.TranslateWithParamWithoutParse("{1} DaysText", daysLeft + " days", daysLeft);
                    } else if(this.state.trialMinsLeft > 60){
                        let hoursLeft = Math.ceil(this.state.trialMinsLeft/(60));
                        trialLeftTxt = PremiumUtil.TranslateWithParamWithoutParse("{1} HoursText", hoursLeft + " hours", hoursLeft);
                    } else {
                        trialLeftTxt = PremiumUtil.TranslateWithParamWithoutParse("{1} HourText", "1 hour", 1);
                    }
                    extensionInfo = '<div>' + PremiumUtil.TranslateWithParamWithoutParse("messageTrialOngoing", '', trialLeftTxt) + '</div>';
                }
            } else if (this.state.extensionSatus === "premium") {
                if(this.state.freePremiumMinsLeft) {
                    let freePremiumLeftTxt = "";
                    if(this.state.freePremiumMinsLeft > (60*25)) {
                        let daysLeft = Math.ceil(this.state.freePremiumMinsLeft/(60*24));
                        freePremiumLeftTxt = PremiumUtil.TranslateWithParamWithoutParse("{1} DaysText", daysLeft + " days", daysLeft);
                    } else if(this.state.freePremiumMinsLeft > 60){
                        let hoursLeft = Math.ceil(this.state.freePremiumMinsLeft/(60));
                        freePremiumLeftTxt = PremiumUtil.TranslateWithParamWithoutParse("{1} HoursText", hoursLeft + " hours", hoursLeft);
                    } else {
                        freePremiumLeftTxt = PremiumUtil.TranslateWithParamWithoutParse("{1} HourText", "1 hour", 1);
                    }
                    extensionInfo = '<div>' + PremiumUtil.TranslateWithParamWithoutParse("messageFreePremiumOngoing", '', freePremiumLeftTxt) + '</div>';
                }
            }
            else if(this.state.extensionSatus === "trialEnd") {
                extensionInfo = '<div class="text-danger">' + PremiumUtil.TranslateWithParamWithoutParse("messageTrialExpired", "Your trial has expired") + '</div>';
            } 
            else if(this.state.extensionSatus === "premiumEnd") {
                extensionInfo = '<div class="text-danger">' + PremiumUtil.TranslateWithParamWithoutParse("messagePremiumExpired", "Your license has expired") + '</div>';
            }
            if(extensionInfo && document.getElementById("extensionInfoBlock")) {
                document.getElementById("extensionInfoBlock").innerHTML = extensionInfo;
            }
        }
    }
    renderClickHere() {
        var clickTrans = PremiumUtil.Translate("ppClickHere", "Click here");
        var clickHereLink = '<a href="#">' + clickTrans + "</a>";
        var baseManageSubscription = <span><a href='#'>{clickTrans}</a>&nbsp; to mange your subscription!</span>
        var manageSubscription = PremiumUtil.TranslateWithParam("ppToManageYourSubscription", baseManageSubscription, clickHereLink);
        return (
            manageSubscription
        );
    }
    render() {
        return (
            <Router>
                <PremiumSignupPopup open={this.state.openSignup} onClose={e => this.setState(c=> {c.openSignup = false; return c;})}/>
                <div className="buy-email-exist" onClick={e => this.setState(c=> {c.openSignup = true; return c;})}>
                    {PremiumUtil.Translate("ppAlreadyHaveAccount", "Already have an account?")}&nbsp;
                    {this.renderClickHere()}
                </div>
            </Router>
        );
    }
}

class InstallButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasExtension: true
        };
        this.languageSelected = PremiumUtil.DetectLanguage();
    }
    componentDidMount() {
        this.checkBlurInstalled().then(() => {
            if(!this.state.hasExtension && document.getElementById('affiliateBlock')) {
                document.getElementById('affiliateBlock').style.display = 'block';
            }
        });
    }
    checkBlurInstalled() {
        return PremiumUtil.CallWhatAmI().then(resp => {
            if(PremiumUtil.CanShowInstall()) {
                PremiumUtil.CheckBlurInstalled().then((resp) => {
                    this.setState(c=> {
                        c.hasExtension = resp;
                        return c;
                    })
                }).catch((err) => {
                    this.setState(c=> {
                        c.hasExtension = false;
                        return c;
                    });
                })
            }
        }).catch(err => {});
    }
    installClick() {
        PremiumUtil.InstallClick('install-premium', this.languageSelected);        
    }
        
    render() {
        if (!this.state.hasExtension) {
            return (
                <div>
                    <Button primary onClick={this.installClick.bind(this)}>{PremiumUtil.Translate("lpInstallFree", "Install Blur.live")}</Button>
                </div>
            );
        } else return "";
    }
}

ReactGAInstance.Initialize();
let isBuyAction = false;
if(window.location && window.location.href && window.location.href.indexOf("action=buy") > -1) {
    isBuyAction = true;
}
ReactDOM.render(<IndexPremium isBuyAction={isBuyAction}/>, document.getElementById('paymentBlock'));
ReactDOM.render(<ManageLink isBuyAction={isBuyAction}/>, document.getElementById('manageBlock'));
ReactDOM.render(<InstallButton />, document.getElementById('installBlurBlock'));
